<template>
  <div class="support-wrapper" :class="{theme, last_item: isLast }">
    <div
      class="title-wrapper flex justify_between"
      :class="theme"
      @click="expand = !expand"
    >
      <h3 class="title bold my1">
        {{ title }}
      </h3>

      <toggle-arrow :value="expand" :dark="!hasContact"></toggle-arrow>
    </div>
    <collapse :value="expand" flexible-height>
      <div class="collapse-wrapper">
        <p class="description" v-if="!!description">{{ description }}</p>
        <slot></slot>
        <div class="contact mt5" v-if="hasContact">
          <span>{{ $t('cms.support.ContactUs') }}: </span>
          <a :href="`mailto:support@hihellocoupon.com?subject=${title}`" class="email-link">support@hihellocoupon.com</a>
        </div>
      </div>
    </collapse>
  </div>
</template>

<script>
import Collapse from './global/Collapse.vue';
import ToggleArrow from './global/ToggleArrow.vue';

export default {
  components: { Collapse, ToggleArrow },
  props: {
    title: { type: String, required: true },
    description: { type: String },
    hasContact: { type: Boolean },
    isLast: { type: Boolean },
  },
  data() {
    return {
      expand: false,
    };
  },
  computed: {
    theme() {
      return !this.hasContact ? 'dark' : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.support-wrapper {
  background: $color_background_slightly_yellow;
  margin: 0 -16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  &.dark {
    border-bottom: 1px solid white;
  }
}

.title-wrapper {
  padding: 10px 16px;
  .title {
    font-size: 14px;
  }
  &.dark {
    background: $color_black;
    .title {
      color: white;
    }
  }
  & .last {
    padding-bottom: $base_spacing;
  }
}

.collapse-wrapper {
  padding: 0 16px;
  margin-bottom: 16px;
}

.description {
  padding-right: 32px;
  text-align: justify;
  line-height: 20px;
}

.email-link {
  color: $color_black;
  font-weight: bold;
}

.last_item {
  border-bottom: none;
}

</style>
